import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import { Row, Col, Button, Table, Modal, Form } from "react-bootstrap";
import {
  fetchTasks,
  clearFilter,
} from "../../store/actions/projects/tasksActions";
import { getProject } from "../../store/actions/projects/projectsActions";
import {
  fetchProjectTasks,
  deleteProjectTask,
  setProjectTask,
} from "../../store/actions/projects/projectTasksActions";
import { ACTIVE } from "../../store/actions/activities/activitiesActions";
import {
  toggleShowAlert,
  ERROR_ALERT,
  toggleDialogBox,
} from "../../store/actions/commonActions";
import {
  MANAGER,
  PROJECT_ADMIN,
  PORTAL_ADMIN,
  PROJECT_SPONSOR,
  TEAM_LEADER,
} from "../../store/actions/users/usersActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";

import "../../css/projects.css";

import AddTasksToProject from "./AddTasksToProject";
import { updateTargetTransaction } from "../../store/actions/timesheet/taskActions";

class ManageTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      modalType: "",
      disableConfirm: true,
      target: null,
      newTarget: null,
      projectTask: {},
    };
  }

  componentDidMount() {
    const roleId = Cache.getItem("roleId");

    if (
      roleId === MANAGER ||
      roleId === PROJECT_ADMIN ||
      roleId === PORTAL_ADMIN ||
      roleId === PROJECT_SPONSOR ||
      roleId === TEAM_LEADER
    ) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const projectId = urlParams.get("id");
      this.props.getProject(projectId);
    } else {
      this.props.history.push("/dashboard");
    }
  }

  handleModal = async (action, projectTask) => {
    this.setState({
      show: true,
      modalType: action,
      target: projectTask.target,
      projectTask,
    });
  };

  renderModal = () => {
    let modalTitle = "";
    let modalBody = "";
    let onHideFunction = {};
    let onClickCancel = {};
    let onClickConfirm = {};
    let specialForm = "";
    const confirmButtonText = "Yes, Confirm";
    const cancelButtonText = "Nope";
    const spinner = '<span class="spinner-border spinner-border-sm"></span>'; //html of react spinner\
    // const taskEntry = this.props.dailyTasks.taskEntry;

    const updateTransaction = (e) => {
      const newTarget = parseInt(e.target.value);
      this.state.target = newTarget;
      const initialTarget = this.state.projectTask.target;

      const minRemarkLength = 1;
      console.log("this.state.target", this.state.target);
      console.log("newTarget", newTarget);

      console.log(this.state.target !== newTarget);
      console.log(this.state.target >= minRemarkLength);
      console.log(
        this.state.target >= minRemarkLength && this.state.target !== newTarget
      );

      // false pwede
      // true bawal

      if (
        this.state.target !== initialTarget &&
        this.state.target >= minRemarkLength
      ) {
        this.setState({ disableConfirm: false });
      } else {
        this.setState({ disableConfirm: true });
      }
    };

    switch (this.state.modalType) {
      case "Add Total Transaction":
        const urlParams = new URLSearchParams(this.props.location.search);
        const projectId = urlParams.get("id");
        modalTitle = "Add Total Target Transaction";

        modalBody = "Input Total Target Transaction";

        onClickConfirm = async () => {
          console.log(this.state);
          await this.props.updateTargetTransaction(
            this.state.projectTask.id,
            projectId,
            this.state.target
          );

          this.setState({ show: false });
        };

        specialForm = (
          <>
            <Row className="mt-3">
              <Col>
                <Form>
                  <Form.Group>
                    <Form.Control
                      type="number"
                      onChange={updateTransaction}
                      defaultValue={parseInt(this.state.target ?? 0)}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </>
        );
        break;

      case "Confirm Dialogue":
        this.state.disableConfirm = false;
        modalTitle = "Remove Confirmation";

        modalBody = "Are you sure you want to proceed?";

        onClickConfirm = async () => {
          console.log(this.state.projectTask);
          await this.props.deleteProjectTask(this.state.projectTask);

          this.state.show = false;
        };
        break;

      default:
      // code block
    }

    onHideFunction = () => {
      this.setState({ show: false });
      this.setState({ disableConfirm: true });
    };

    onClickCancel = () => {
      this.setState({ show: false });
      this.setState({ disableConfirm: true });
    };

    return (
      <Modal show={this.state.show} onHide={() => onHideFunction()}>
        <Modal.Header closeButton>
          <Modal.Title> {modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalBody}
          {specialForm ?? ""}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="nopeCancel"
            size="sm"
            variant="secondary"
            className="float-left"
            onClick={() => {
              onClickCancel();
            }}
          >
            {cancelButtonText}
          </Button>
          <Button
            id="yesConfirm"
            size="sm"
            variant="primary"
            disabled={this.state.disableConfirm}
            onClick={() => {
              const confirmButton = document.getElementById("yesConfirm");
              confirmButton.innerHTML = spinner;
              onClickConfirm();
            }}
          >
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  renderProjectTasks = () => {
    const projectTasks = this.props.projects.projectTasks;

    let projectTasksList = "";

    if (projectTasks) {
      projectTasksList = projectTasks.length ? (
        projectTasks.map((projectTask, key) => {
          return (
            <tr key={key}>
              <td>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push(
                      "/projects/tasks/view?id=" +
                        projectTask.id +
                        "&project_id=" +
                        projectTask.project_id
                    );
                  }}
                >
                  {projectTask.name}
                </Link>
              </td>
              <td className="align-center">{projectTask.target ?? "0"}</td>
              <td className="d-flex justify-content-end w-100">
                <Button
                  size="sm"
                  className="btn-primary mr-1"
                  onClick={() => {
                    this.projectTask = projectTask;
                    this.handleModal("Add Total Transaction", projectTask);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  &nbsp;Add Target
                </Button>
                <Button
                  size="sm"
                  className="btn-primary"
                  onClick={() => {
                    this.projectTask = projectTask;
                    this.handleModal("Confirm Dialogue", projectTask);
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} /> Remove
                </Button>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={2}>
            <i>Loading...</i>
          </td>
        </tr>
      );
    } else {
      projectTasksList = (
        <tr>
          <td colSpan={2}>
            <p className="text-danger">No results found.</p>
          </td>
        </tr>
      );
    }

    return (
      <Table>
        <thead>
          <tr>
            <th width="35%" className="align-center">
              Task Name
            </th>
            <th width="35%" className="align-center">
              Target Transaction per Month
            </th>
            <th width="30%" className="align-center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>{projectTasksList}</tbody>
      </Table>
    );
  };

  render() {
    const project = this.props.projects.project;

    if (project && project.is_disabled) {
      this.props.toggleShowAlert(
        true,
        ERROR_ALERT,
        "You are not allowed to perform this action."
      );
      this.props.history.push("/projects/disabled");
    }

    return (
      <React.Fragment>
        {this.state.show ? this.renderModal() : <></>}

        <AddTasksToProject />
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h5>Manage Tasks</h5>
            <div>{project.project_name}</div>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <div className="float-right mt-3">
              <Button
                size="sm"
                onClick={() => {
                  this.props.toggleDialogBox(true);
                  this.props.clearFilter();
                  this.props.fetchTasks({ active: ACTIVE });
                }}
              >
                Add Task to Project
              </Button>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {this.renderProjectTasks()}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  projects: state.projects,
  tasks: state.tasks,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTasks: (...args) => dispatch(fetchTasks(...args)),
    getProject: (...args) => dispatch(getProject(...args)),
    fetchProjectTasks: () => dispatch(fetchProjectTasks()),
    setProjectTask: (...args) => dispatch(setProjectTask(...args)),
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),

    deleteProjectTask: (...args) => dispatch(deleteProjectTask(...args)),
    clearFilter: () => dispatch(clearFilter()),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    updateTargetTransaction: (...args) =>
      dispatch(updateTargetTransaction(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageTasks)
);
